import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Portfolio from "./components/Portfolio";
import LoginPage from "./components/admin/LoginPage";
import RegisterPage from "./components/admin/RegisterPage";
import AdminLayout from "./components/admin/AdminLayout";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import DashboardPage from "./components/admin/DashboardPage";
import TranslationsPage from "./components/admin/TranslationsPage";
import ProjectsPage from "./components/admin/ProjectsPage";
import SkillsPage from "./components/admin/SkillsPage";
import WorkHistoryPage from "./components/admin/WorkHistoryPage";
import AboutPage from "./components/admin/AboutPage";
import ContactsPage from "./components/admin/ContactsPage";
import CertificatesPage from "./components/admin/CertificatesPage";
import CvPage from "./components/admin/CvPage";

import "./css/variables.css";
import "./css/reset.css";
import "./css/global.css";
import "./css/animations.css";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Portfolio */}
          <Route path="/" element={<Portfolio />} />

          {/* Admin Login */}
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/admin/register" element={<RegisterPage />} />

          {/* Admin Protected Routes */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="translations" element={<TranslationsPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="skills" element={<SkillsPage />} />
            <Route path="work-history" element={<WorkHistoryPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="cv" element={<CvPage />} />
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="certificates" element={<CertificatesPage />} />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
